import React from "react";
import Layout from "app/components/layouts";
import LoanTypeStepper from "app/components/common/LoanTypeStepper";
import DeclarationSignaturesPartOne from "app/components/Individual/declarationSignatures/DeclarationSignaturesPartOne";

const DeclarationSignatures: React.FC = () => {
  return (
    <>
      <Layout>
        <LoanTypeStepper />
        <DeclarationSignaturesPartOne />
      </Layout>
    </>
  );
};

export default DeclarationSignatures;
